import React, { useEffect, createElement } from 'react';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function MetaPixel() {
  useEffect(() => {
    // Inject Meta Pixel script
    ;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      // Safely append to head instead of inserting before existing script
      const head = b.getElementsByTagName('head')[0];
      if (head) {
        head.appendChild(t);
      } else {
        b.body.appendChild(t);
      }
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel
    window.fbq('init', '1423074459182335');
    // Track PageView
    window.fbq('track', 'PageView');
    // Set up Lead tracking on checkout button clicks
    const handleCheckoutClick = () => {
      if (typeof window.fbq === 'function') {
        window.fbq('track', 'Lead');
      }
    };
    // Use a small delay to ensure buttons are rendered
    const setupTracking = () => {
      const checkoutButtons = document.querySelectorAll('.checkout-btn, .cta-button, .buy-button, button[data-checkout], a[href*="hotmart"], a[href*="pay.hotmart"], a[href*="checkout"]');
      checkoutButtons.forEach(btn => {
        btn.addEventListener('click', handleCheckoutClick);
      });
      return checkoutButtons;
    };
    const timer = setTimeout(() => {
      const buttons = setupTracking();
      // Cleanup function
      return () => {
        buttons.forEach(btn => {
          btn.removeEventListener('click', handleCheckoutClick);
        });
      };
    }, 100);
    return () => clearTimeout(timer);
  }, []);
  // Noscript fallback
  return <noscript data-id="element-106">
      <img height="1" width="1" style={{
      display: 'none'
    }} src="https://www.facebook.com/tr?id=1423074459182335&ev=PageView&noscript=1" alt="" data-id="element-107" />
    </noscript>;
}